<template>
  <div class="im-smails">
    <svg class="im-smails__icon">
      <use xlink:href="#icon-emoji"></use>
    </svg>
    <div class="im-smails__content">
      <div class="im-smails__wrapper">
          <img
            v-for="(item, index) in items"
            :key="index"
            :id="item.id"
            :src="item.src"
            @click="click"
          >
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Smails',
    data(){
      return {
        items: [
          { id: ":-)", src: window.STATIC_URL + "/img/smilies/ab.gif" },
          { id: ":-D", src: window.STATIC_URL + "/img/smilies/ag.gif" },
          { id: ":-(", src: window.STATIC_URL + "/img/smilies/ac.gif" },
          { id: ":-P", src: window.STATIC_URL + "/img/smilies/ae.gif" },
          { id: ";-)", src: window.STATIC_URL + "/img/smilies/ad.gif" },
          { id: "*beer*", src: window.STATIC_URL + "/img/smilies/az.gif" },
          { id: "*kiss*", src: window.STATIC_URL + "/img/smilies/aw.gif" },
          { id: "*wall*", src: window.STATIC_URL + "/img/smilies/bu.gif" },
          { id: "]:->", src: window.STATIC_URL + "/img/smilies/aq.gif" },
          { id: "8-)", src: window.STATIC_URL + "/img/smilies/af.gif" },
          { id: ":-\\", src: window.STATIC_URL + "/img/smilies/ao.gif" },
          { id: "@=", src: window.STATIC_URL + "/img/smilies/bb.gif" },
          { id: ":-*", src: window.STATIC_URL + "/img/smilies/aj.gif" },
          { id: "*rose*", src: window.STATIC_URL + "/img/smilies/ax.gif" },
          { id: ":-[", src: window.STATIC_URL + "/img/smilies/ah.gif" },
          { id: "*rofl*", src: window.STATIC_URL + "/img/smilies/bj.gif" },
          { id: ":'(", src: window.STATIC_URL + "/img/smilies/ak.gif" },
          { id: "*bye*", src: window.STATIC_URL + "/img/smilies/br.gif" },
          { id: "*crazy*", src: window.STATIC_URL + "/img/smilies/bm.gif" },
          { id: "*yahoo*", src: window.STATIC_URL + "/img/smilies/bp.gif" },
          { id: "%-)", src: window.STATIC_URL + "/img/smilies/be.gif" },
          { id: "*bad*", src: window.STATIC_URL + "/img/smilies/by.gif" },
          { id: "=-O", src: window.STATIC_URL + "/img/smilies/ai.gif" },
          { id: "*write*", src: window.STATIC_URL + "/img/smilies/bv.gif" },
          { id: "*sos*", src: window.STATIC_URL + "/img/smilies/bx.gif" },
          { id: "*dance*", src: window.STATIC_URL + "/img/smilies/bz.gif" },
          { id: "*secret*", src: window.STATIC_URL + "/img/smilies/ca.gif" },
          { id: "*fool*", src: window.STATIC_URL + "/img/smilies/cc.gif" },
          { id: "*yes*", src: window.STATIC_URL + "/img/smilies/cf.gif" },
          { id: "*whistle*", src: window.STATIC_URL + "/img/smilies/cb.gif" },
          { id: "*scratch*", src: window.STATIC_URL + "/img/smilies/cd.gif" },
          { id: "*acute*", src: window.STATIC_URL + "/img/smilies/ce.gif" },
          { id: "*good*", src: window.STATIC_URL + "/img/smilies/cg.gif" },
          { id: "*boredom*", src: window.STATIC_URL + "/img/smilies/ch.gif" },
          { id: "*mocking*", src: window.STATIC_URL + "/img/smilies/ci.gif" },
          { id: "*dance1*", src: window.STATIC_URL + "/img/smilies/cj.gif" },
          { id: "*pardon*", src: window.STATIC_URL + "/img/smilies/ck.gif" },
          { id: "*thank-you*", src: window.STATIC_URL + "/img/smilies/cl.gif" },
          { id: "*facepalm*", src: window.STATIC_URL + "/img/smilies/cp.gif" },
          { id: "*five*", src: window.STATIC_URL + "/img/smilies/cn.gif" },
          { id: "*popcorn*", src: window.STATIC_URL + "/img/smilies/co.gif" },
          { id: "*dance2*", src: window.STATIC_URL + "/img/smilies/cm.gif" },
          { id: "*no*", src: window.STATIC_URL + "/img/smilies/cq.gif" }
        ]
      };
    },
    methods: {
      click(e){
        const data = e.target.getAttribute('id');
        this.$emit('insert', data);
      }
    }
  };
</script>

<style lang="scss">
  .im-smails {
    $root: &;

    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 8px 0 0;
    width: 36px;
    height: 36px;
    position: relative;

    &__icon {
      fill: #8D96A1;
      width: 20px;
      height: 20px;
    }

    &__content {
      display: none;
      box-sizing: border-box;
      background: #FFF;
      border: 1px solid #D6D6D6;
      padding: 10px;
      width: 236px;
      position: absolute;
      bottom: 36px;
      left: -10px;

      &::after {
        display: block;
        content: "";
        background: #fff;
        border-top: 1px solid #d6d6d6;
        border-left: 1px solid #d6d6d6;
        margin: 0 0 0 -6px;
        width: 8px;
        height: 8px;
        position: absolute;
        bottom: -6px;
        left: 29px;
        transform: rotate(225deg);
      }
    }

    &__wrapper {
      overflow: hidden;
      overflow-y: scroll;
      height: 120px;

      &::-webkit-scrollbar {
        width: 4px;

        &-track {
          background: #FFFFFF;
        }

        &-thumb {
          background: #C6CBD0;
          border-radius: 2px;
        }
      }
    }

    &:hover {
      #{$root}__content {
        display: block;
      }
    }
  }
</style>